import React from 'react';
import { LayoutGridIcon, PuzzleIcon, SlidersHorizontalIcon, ClockIcon, BarChart3Icon, FolderOpenIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { scrollToBuy } from '../utils/constants';
const MODULES = [{
  number: '01',
  title: 'Visual Support System™',
  icon: LayoutGridIcon,
  accent: 'bg-sage',
  body: 'Ready-to-use visual tools designed to support communication, routines, transitions, participation, regulation, and classroom independence.',
  tags: 'Schedules · First–Then Boards · Choice Boards · Routine Cards · Communication · Transitions'
}, {
  number: '02',
  title: 'Adaptable Activity Library™',
  icon: PuzzleIcon,
  accent: 'bg-lavender',
  body: 'Access structured, ready-to-use activities designed around clear educational and functional objectives. Each activity includes implementation guidance, materials, support options, adaptations, and different levels of complexity.',
  tags: 'Literacy · Numeracy · Communication · Matching · Sequencing · Functional Skills'
}, {
  number: '03',
  title: 'Differentiation Toolkit™',
  icon: SlidersHorizontalIcon,
  accent: 'bg-mustard',
  body: 'Adapt professional learning activities in minutes without rebuilding every resource from a blank page. Modify support, instructions, response formats, complexity, prompting, communication, and independence levels.',
  tags: 'High Support · Moderate Support · Independence · Prompting · Complexity · Adaptations'
}, {
  number: '04',
  title: 'Routines & Classroom Systems™',
  icon: ClockIcon,
  accent: 'bg-steel',
  body: 'Open complete, structured classroom routines whenever you need them. Support arrival, independent work, learning stations, transitions, requesting help, regulation breaks, task completion, and end-of-day routines.',
  tags: 'Visual Routines · Transitions · Independence · Work Systems · Checklists'
}, {
  number: '05',
  title: 'Planning & Progress Toolkit™',
  icon: BarChart3Icon,
  accent: 'bg-coral',
  body: 'Plan, observe, track, and adjust without creating unnecessary paperwork. Use practical planning templates, observation tools, skill trackers, independence records, adaptation notes, and next-step planning resources.',
  tags: 'Planning · Observation · Tracking · Adaptations · Progress · Next Steps'
}, {
  number: '06',
  title: 'Ready-To-Use Resource Vault™',
  icon: FolderOpenIcon,
  accent: 'bg-petrol',
  body: 'Access a complete library of classroom-ready materials that can be printed, adapted, reused, and organized according to student needs. Use visual cards, boards, checklists, templates, activities, trackers, sequencing tools, and reusable classroom resources.',
  tags: 'Printables · Visual Cards · Templates · Activities · Trackers · Classroom Tools'
}];
export function Modules() {
  return <section aria-labelledby="modules-title" className="w-full bg-white px-3 py-7 sm:px-5" data-id="element-122" data-mp="3jcyrbhmpj66k">
      <div className="mx-auto max-w-6xl" data-id="element-123" data-mp="3o5icaznq53le">
        <div className="text-center" data-id="element-124" data-mp="3o6bf5pjkb8y9">
          <span className="font-head text-[10px] uppercase tracking-[0.14em] text-steel sm:text-xs" data-id="element-125" data-mp="1coq1m0lxfgcl">
            The Complete Teaching Collection
          </span>
          <h2 id="modules-title" className="mt-1 font-head text-2xl uppercase leading-[0.98] text-ink sm:text-4xl" data-id="element-126" data-mp="17okduvis2dzs">
            Inside the main box set — six complete professional modules
          </h2>
        </div>

        <div className="mt-4 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-127" data-mp="tqdoy4vt3oc9">
          {MODULES.map(mod => {
          const Icon = mod.icon;
          return <button key={mod.number} type="button" onClick={scrollToBuy} aria-label={`Go to the purchase section — ${mod.title}`} className="flex flex-col overflow-hidden rounded-xl border border-ink/10 bg-cream text-left transition-colors duration-150 ease-out hover:border-ink/30" data-id="element-128" data-mp="ot3si5a02cex">
                <span className={`h-1.5 w-full ${mod.accent}`} aria-hidden="true" data-id="element-129" data-mp="2f2x7b6a1e7n4" />
                <span className="flex flex-1 flex-col p-3" data-id="element-130" data-mp="2a5op55ow23lv">
                  <span className="flex items-center gap-2" data-id="element-131" data-mp="2a785ewajoenn">
                    <span className={`flex h-8 w-8 items-center justify-center rounded-lg text-white ${mod.accent}`} data-id="element-132" data-mp="jp37gp9k81n6">
                      <Icon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="on4qja6zk0yn" />
                    </span>
                    <span className="text-[10px] font-bold uppercase tracking-widest text-muted" data-id="element-134" data-mp="sn57p2lgyq9e">
                      Module {mod.number}
                    </span>
                  </span>
                  <span className="mt-1.5 block font-head text-lg uppercase leading-tight text-ink" data-id="element-135" data-mp="12m4fyk2bojvv">
                    {mod.title}
                  </span>
                  <span className="mt-1 block text-[13px] leading-snug text-body" data-id="element-136" data-mp="1cbxiywoefqoi">{mod.body}</span>
                  <span className="mt-auto block pt-2 text-[10px] font-bold uppercase leading-snug tracking-wide text-petrol" data-id="element-137" data-mp="1gekcd20pxjnt">
                    {mod.tags}
                  </span>
                </span>
              </button>;
        })}
        </div>

        <div className="mt-5 flex flex-col items-center" data-id="element-138" data-mp="1qchztnar7cfd">
          <CtaButton data-id="element-139" data-mp="20gf6bocnfdgr" />
          <TrustRow className="mt-2" data-id="element-140" data-mp="20hqb9rhtyr9g" />
        </div>
      </div>
    </section>;
}